import { Component, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { BasePage } from "../../../shared/base.page";
import { ServiceCaller } from '../../../shared/services/ServiceCaller';
import { DxDataGridComponent, DxValidationGroupComponent } from 'devextreme-angular';
import { UIService } from '../../../shared/services/UIService';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';

@Component({
    templateUrl: './subcontractor.page.html',
})

export class SubContractorPage extends BasePage {

    subcontractors: any[]=[];
    relatedCustomers: any[]=[];
    tasksDataSourceStorage: any;


    constructor(public router: Router, api: ServiceCaller, public uiService: UIService) {
        super(api); 
        this.api.get("/Company/Subcontractor/List").then(c => {
            this.subcontractors = c;
        }); 
        this.api.get("/Company/RelatedCustomer/List").then(c => {
            this.relatedCustomers = c;
        });
        //this.employees = service.getEmployees();
        //this.tasks = service.getTasks();
        this.tasksDataSourceStorage = [];
    }


    getRelateds(key) {
        let item = this.tasksDataSourceStorage.find((i) => i.key === key);
        if (!item) {
            item = {
                key: key,
                dataSourceInstance: new DataSource({
                    store: new ArrayStore({
                        data: this.relatedCustomers,
                        key: "ID"
                    }),
                    filter: ["SubcontractorID", "=", key]
                })
            };
            this.tasksDataSourceStorage.push(item)
        }
        return item.dataSourceInstance;
    }

}



// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/admin/pages/Companies/subcontractor.page.ts